import { gql } from '@apollo/client'

export const UPDATE_CHART_CATEGORY = gql`
  mutation UpdateChartCategory($data: UpdateChartCategoryInput!) {
    updateChartCategory(data: $data) {
      id
      title
      chartId
    }
  }
`

export const CREATE_CHART_CATEGORIES = gql`
  mutation CreateChartCategories(
    $chartId: Int!
    $data: [ChartCategoryInput!]!
  ) {
    createChartCategories(chartId: $chartId, data: $data) {
      id
      title
      chartId
    }
  }
`
